<div class="text-box-container">
  <div class="question-header">
    <h6 class="m-0 p-0" [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
      [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
      [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
      [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor">
      {{ questionNumber }}. {{ question?.question || 'Untitled Question' | titlecase }}@if(question?.required) {
      <span [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor">*</span>
      }
    </h6>

  </div>
  <div class="question-content">
    <textarea class="input-field" [class.is-invalid]="isInvalid" [value]="value" (input)="onInputChange($event)"
      (blur)="onBlur()" rows="4" cols="50" [placeholder]="placeholder"></textarea>
  </div>
  <!-- @if(isInvalid) {
      <div class="error-message">
        {{ errorMessage }}
      </div>
    } -->
</div>